import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { MinProjectDTO } from 'src/app/features/subscription/types/MinProjectDTO';
import { RsvpDisplay } from 'src/app/shared/types/RsvpDisplay';
import { PublicMeetingDTO } from 'src/app/shared/types/PublicMeetingDTO';
import { TimeFormatPipe } from '../../../../shared/pipes/time-format.pipe';
import { RsvpPageService } from '../../rsvp-page.service';
import { GTranslateWidgetService } from 'src/app/shared/services/gtranslate-widget.service';

@Component({
  selector: 'app-rsvp-confirm-component',
  standalone: true,
  imports: [CommonModule, MatIconModule, TimeFormatPipe],
  templateUrl: './rsvp-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../rsvp.component.scss', './rsvp-confirm.component.scss'],
})
export class RsvpConfirmComponent {
  projectGuid: string | null = null;
  stakeGuid: string | null = null;
  projectInfo: MinProjectDTO | null = null;
  private subscription: Subscription | null = null;

  rsvpDisplay: RsvpDisplay | undefined;
  meeting: PublicMeetingDTO | null = null;

  constructor(
    _rsvpService: RsvpPageService,
    private gTranslateService: GTranslateWidgetService
  ) {
    this.rsvpDisplay = _rsvpService.setupFormDisplay();
  }

  ngOnInit(): void {
    this.subscription =
      this.rsvpDisplay?.publicMeeting$.subscribe((meeting) => {
        this.meeting = meeting;
        setTimeout(() => this.gTranslateService.retranslate());
      }) ?? null;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
